<div>
    <div class="preview-video-screen"
         [ngClass]="{'preview-video-screen': isInMobilePreviewMode, 'video-screen-md': !isInMobilePreviewMode}"
         *ngIf="!isSplashScreenVisible && !isInteraction" (click)="setSplashScreen($event)"></div>
    <div [ngClass]="{'mobile-preview-video-screen': isInMobilePreviewMode, 'splash-screen-md': !isInMobilePreviewMode}" *ngIf="isSplashScreenVisible"></div>
    <div [ngClass]="{'mobile-preview-button-screen': isInMobilePreviewMode, 'buttons-screen': !isInMobilePreviewMode}" *ngIf="isSplashScreenVisible">
        <div class="click-center" (click)="playOrPauseVideo()"></div>
        <div class="click-left-area" *ngIf="!disabledNavIcons" (click)="goBackwards()"></div>
        <div class="click-right-area" *ngIf="!disabledNavIcons" (click)="goForward()"></div>
        <div class="arrow">
            <i class="pbi-icon-mini pbi-fast-forward left text-white" [class.disabled]="disabledNavIcons"></i>
            <div [style.visibility]=" backwardText ? 'initial' : 'hidden'">{{ 'PLAYBACK_CONTROLS.10_SECONDS' | translate }}</div>
        </div>
        <i class="pbi-icon-mini text-white" [class.pbi-play]="!isVideoPlaying"
           [class.pbi-pause]="isVideoPlaying" (click)="playVideo($event)"></i>
        <div class="arrow">
            <i class="pbi-icon-mini pbi-fast-forward text-white" [class.disabled]="disabledNavIcons"></i>
            <div [style.visibility]=" forwardText ? 'initial' : 'hidden'">{{ 'PLAYBACK_CONTROLS.10_SECONDS' | translate }}</div>
        </div>
    </div>

    <eocm-timeline *ngIf="isSplashScreenVisible" [ngClass]="{'timeline-visibility': !isInMobilePreviewMode, 'display-block': isInMobilePreviewMode }"></eocm-timeline>
    <eocm-resolution *ngIf="isSplashScreenVisible && !isInMobilePreviewMode"
                    [ngClass]="{'mobile-preview-resolution': isInMobilePreviewMode, 'resolution-m': !isInMobilePreviewMode}"></eocm-resolution>
</div>
